<template>
  <g>
    <line
      v-for="(cluePoint, index) in cluePoints"
      :key="index"
      :x1="attributes.cx + cluePoint[0]"
      :y1="attributes.cy + cluePoint[1]"
      :x2="attributes.cx + cluePoint[2]"
      :y2="attributes.cy + cluePoint[3]"
      stroke-width="1"
    />
  </g>
</template>

<script>
export default {
  props: ["attributes"],
  data() {
    return {
      cluePoints: [
        [-2, -8, 2, -4], // 12:00
        [2, -8, -2, -4],
        [2, -6, 6, -2], // 1:30
        [6, -6, 2, -2],
        [4, -2, 8, 2], // 3:00
        [8, -2, 4, 2],
        [2, 2, 6, 6], // 4:30
        [6, 2, 2, 6],
        [-2, 4, 2, 8], // 6:00
        [2, 4, -2, 8],
        [-6, 2, -2, 6], // 7:30
        [-2, 2, -6, 6],
        [-8, -2, -4, 2], // 9:00
        [-4, -2, -8, 2],
        [-6, -6, -2, -2], // 10:30
        [-2, -6, -6, -2],
      ],
    };
  },
};
</script>
